// @flow
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

import * as R from "ramda";

import { getFilteredFiles } from "src/reducers";

import { FieldValue } from "../Values/styles";

type Props = {
  oldFileIds: Array<string>,
};

const OldFiles = ({ oldFileIds }: Props) => {
  const oldFiles = useSelector(({ app }) => getFilteredFiles(app, oldFileIds));

  const oldFileNames = useMemo(
    // Sometimes duplicates with different ids are in the notification payload (sc-17712)
    () => R.uniq(oldFiles.map((file) => file?.originalName || "")),
    [oldFiles],
  );

  return (
    <>
      {oldFileNames.map(
        (fileName, index) =>
          fileName && (
            <FieldValue old key={oldFileIds[index]}>
              {fileName.length > 18 ? `${fileName.slice(0, 16)}...` : fileName}
            </FieldValue>
          ),
      )}
    </>
  );
};

export default OldFiles;
